import { render, staticRenderFns } from "./thirdStep.vue?vue&type=template&id=a3e66fce&scoped=true"
import script from "./thirdStep.vue?vue&type=script&lang=ts"
export * from "./thirdStep.vue?vue&type=script&lang=ts"
import style0 from "./thirdStep.vue?vue&type=style&index=0&id=a3e66fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e66fce",
  null
  
)

export default component.exports